import React from 'react';
import { motion } from 'framer-motion';

const Section = ({ children, delay = 0 }) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay }}
      className="mb-16"
    >
      {children}
    </motion.section>
  );
};

export default Section;
